import { render, staticRenderFns } from "./DetailAsetTakBerwujudPage.vue?vue&type=template&id=61aff69d"
import script from "./DetailAsetTakBerwujudPage.vue?vue&type=script&lang=js"
export * from "./DetailAsetTakBerwujudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports